import { render, staticRenderFns } from "./WholeSaleInfo.vue?vue&type=template&id=ab13c6b6"
import script from "./WholeSaleInfo.vue?vue&type=script&lang=js"
export * from "./WholeSaleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports